import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@material-ui/core';
import { dotNotationExtractor, isFunction } from 'utils/functions';
import { formatter } from 'constantes/constants';
import Chip, { ChipColors } from 'components/Chip';
import MultipleRenderer from './multiple';
import Check from 'components/Check';

function Row({ columns, data = {} }) {
  return (
    <TableRow>
      {columns.map((col, index) => {
        let cellContent = col.component || dotNotationExtractor(data, col.name);
        cellContent = isFunction(cellContent) ? cellContent(data) : cellContent;
        switch (col.type) {
          case 'number': cellContent = formatter.format(cellContent ?? 0);
            break;
          case 'MULTIPLEVAL_TYPE': cellContent = <MultipleRenderer value={cellContent} index={index} />;
            break;
          case 'money': cellContent = `$${formatter.format(cellContent ?? 0)}`;
            break;
          case 'check': cellContent = <Check activo={cellContent} />;
            break;
          case 'active': cellContent = (
            <Chip
              label={cellContent ? 'ACTIVO' : 'INACTIVO'}
              color={cellContent ? ChipColors.GREEN : ChipColors.RED}
            />
          );
            break;
          default:
        }
        return (
          <TableCell key={`Col${String(index)}`} align={col.align || 'left'} style={{ width: col.width ? col.width : '' }}>
            {cellContent}
          </TableCell>
        );
      })}
    </TableRow>
  );
}

Row.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.array]).isRequired,
  data: PropTypes.oneOfType([PropTypes.object]),
};

export default Row;
